import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-email-dialog',
    templateUrl: './email-dialog.component.html',
    styleUrl: './email-dialog.component.scss',
    standalone: false
})
export class EmailDialogComponent {
  readonly dialogRef = inject(MatDialogRef<EmailDialogComponent>);
  readonly data = inject(MAT_DIALOG_DATA)

  constructor() { }

  close() {
    window.location.href = '/landing';
  }
}
